import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Checkbox } from '@/_components/checkbox';
import styles from './footer-reasons.module.scss';
import { ENUM_DENIED_REASONS, LABEL_DENIED_REASONS } from './constants';
import type { FormType } from '../approval-mat-form/types';

function FooterReasons() {
  const {
    register,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useFormContext<FormType>();

  const valueDeniedReasons = 'valuesReasons.value';
  const valueComment = 'valuesReasons.comment';

  const whatchValueDeniedReasons = useWatch({ name: valueDeniedReasons });

  // Todo validar essa funcao, para remover a complexidade.. O tratamento deve ficar no onSubmit do form
  const handleChange = (reasonName: string) => {
    const valuesDeniedReasons = getValues(valueDeniedReasons);

    if (valuesDeniedReasons) {
      if (valuesDeniedReasons.includes(reasonName)) {
        const removeValue: string[] = valuesDeniedReasons.filter(
          reason => reason !== reasonName,
        );

        return setValue(valueDeniedReasons, removeValue);
      }

      return setValue(valueDeniedReasons, [...valuesDeniedReasons, reasonName]);
    }

    return setValue(valueDeniedReasons, [reasonName]);
  };

  return (
    <div className={styles.container}>
      <span>Reprovado por motivos de:</span>

      <div className={styles.containerFooter}>
        <div className={styles.containerCheckBox}>
          <div className={styles.boxCheckBox}>
            <Checkbox
              classNameLabel={styles.labelCheckbox}
              id={ENUM_DENIED_REASONS.RECEPTTION_RECORD}
              data-testid={ENUM_DENIED_REASONS.RECEPTTION_RECORD}
              label={LABEL_DENIED_REASONS.RECEPTTION_RECORD}
              onClick={() =>
                handleChange(ENUM_DENIED_REASONS.RECEPTTION_RECORD)
              }
            />

            <Checkbox
              classNameLabel={styles.labelCheckbox}
              id={ENUM_DENIED_REASONS.TRAFIC_RECORD}
              data-testid={ENUM_DENIED_REASONS.TRAFIC_RECORD}
              label={LABEL_DENIED_REASONS.TRAFIC_RECORD}
              onClick={() => handleChange(ENUM_DENIED_REASONS.TRAFIC_RECORD)}
            />

            <Checkbox
              classNameLabel={styles.labelCheckbox}
              id={ENUM_DENIED_REASONS.MURDER_RECORD}
              data-testid={ENUM_DENIED_REASONS.MURDER_RECORD}
              label={LABEL_DENIED_REASONS.MURDER_RECORD}
              onClick={() => handleChange(ENUM_DENIED_REASONS.MURDER_RECORD)}
            />
          </div>

          <div className={styles.boxCheckBox}>
            <Checkbox
              classNameLabel={styles.labelCheckbox}
              id={ENUM_DENIED_REASONS.UNDER_AGE}
              data-testid={ENUM_DENIED_REASONS.UNDER_AGE}
              label={LABEL_DENIED_REASONS.UNDER_AGE}
              onClick={() => handleChange(ENUM_DENIED_REASONS.UNDER_AGE)}
            />

            <Controller
              control={control}
              name={valueComment}
              render={({ field: { onChange } }) => (
                <Checkbox
                  classNameLabel={styles.labelCheckbox}
                  id={ENUM_DENIED_REASONS.OTHERS}
                  data-testid={ENUM_DENIED_REASONS.OTHERS}
                  label={LABEL_DENIED_REASONS.OTHERS}
                  onClick={() =>
                    onChange(handleChange(ENUM_DENIED_REASONS.OTHERS))
                  }
                />
              )}
            />
          </div>
        </div>

        {whatchValueDeniedReasons?.length > 0 ? (
          <div>
            <label>Campo para comentários:</label>
            <textarea
              {...register(valueComment)}
              data-testid="valuesReasons-comment"
              placeholder="Digite um comentário"
            />
            {errors?.valuesReasons?.comment ? (
              <small className="text-error">
                {errors?.valuesReasons?.comment.message}
              </small>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export { FooterReasons };
